<template>
  <div :class="['comment-modal', visible ? 'active' : '']">
    <div class='mask' :class="{ hidden: !showMask }" @touchmove="stopPopup" @click="closeModal"></div>
    <div class='wrapper'>
      <div class="footer animated slideInUp">
        <div class='input'>
          <textarea class='textarea'
            maxlength="100"
            v-model.trim="comment"
            :placeholder="placeholder"
          >

          </textarea>
        </div>
        <div class='send'>
          <button class='btn' :class="{ disabled: !comment }" @click="sendComment">
            发送
          </button>
        </div>
        <div class="ui-safe-area-inset"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { exerReq } from '@/api'
export default defineComponent({
  name: 'CommentModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    userId: {
      type: Number,
      default: 0
    },
    replyType: {
      type: Number,
      default: 0
    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  setup(props, cxt) {
    const { proxy: { $showLoading, $hideLoading, $toast } } = getCurrentInstance()

    const comment = ref('')
    const stopPopup = event => {
      event.stopPropagation()
      event.preventDefault()
    }

    const closeModal = () => {
      comment.value = ''
      cxt.emit('close', false)
    }

    const sendComment = async () => {
      if (!comment.value) {
        return
      }
      // console.log('replyType', props.replyType)
      // console.log('id', props.id)
      const fetchApi = props.replyType === 0 ? exerReq.postAddRemark : (props.replyType === 1 ? exerReq.postAddRemarkMessage : exerReq.postAddNag)
      const params = {
        comment: comment.value
      }
      if (props.replyType === 0) {
        params.dialogId = props.id
      } else if (props.replyType === 1) {
        params.remarkId = props.id
      } else {
        params.messageId = props.id
        params.receiverId = props.userId
      }
      $showLoading()
      const res = await fetchApi(params)
      $hideLoading()
      if (res.code === 200) {
        $toast('评论成功')
        comment.value = ''
        // 0 是详情页面回复，1 是全部弹窗回复
        cxt.emit('send-success', props.showMask ? 0 : 1)
      } else {
        $toast(res.message)
      }
    }

    return {
      comment,
      closeModal,
      stopPopup,
      sendComment
    }
  }
})
</script>
<style lang="scss" scoped>
@import url('../style/animation.scss');
.comment-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 12;
  display: none;
  &.active {
    display: block;
  }
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 13;
    background-color: rgba(0, 0, 0, 0.6);
    &.hidden {
      background-color: transparent;
    }
  }
  .footer {
    position: absolute;
    padding: 28px 32px;
    width: 100%;
    bottom: 0;
    background-color: #fff;
    z-index: 20;
    animation-duration: 0.4s;
    box-sizing: border-box;
    border-top: 2px solid #F5F5F7;

    .input {
      margin-bottom: 40px;
      .textarea {
        min-height: 172px;
        width: 100%;
        background-color: #f5f5f5;
        font-size: 32px;
        line-height: 40px;
        padding: 18px 20px;
        box-sizing: border-box;
        border-radius: 8px;
        border: none;
        resize: none;
        color: #212224;
      }
    }

    .send {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn {
        border: none;
        width: 144px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background-color: #ff6600;
        border-radius: 28px;
        color: #fff;
        font-size: 28px;
        &.disabled {
          background-color: rgba(255, 102, 0, .6)
        }
      }
    }
  }
}

</style>
